<!-- Right Sidebar -->
<div class="right-bar" (clickOutside)="hide()" [exclude]="'.right-bar-toggle'">
  <div data-simplebar class="h-100">
    <div class="rightbar-title d-flex align-items-center bg-dark p-3">
      <h5 class="m-0 me-2 text-white">Settings</h5>

      <a href="javascript:void(0);" class="right-bar-toggle-close right-bar-toggle ms-auto" (click)="hide()">
        <i class="mdi mdi-close noti-icon"></i>
      </a>
    </div>
    <hr class="m-0" />
    <div class="p-4">
      <h6 class="mt-4 mb-3">Topbar Color</h6>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="topbar-color"
          id="topbar-color-light"
          value="light"
          [checked]="topbar === 'light'"
          (change)="changeTopbar('light')"
        />
        <label class="form-check-label" for="topbar-color-light">Light</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="topbar-color"
          id="topbar-color-dark"
          value="dark"
          [checked]="topbar === 'dark'"
          (change)="changeTopbar('dark')"
        />
        <label class="form-check-label" for="topbar-color-dark">Dark</label>
      </div>
      <h6 class="mt-4 mb-3 sidebar-setting">Sidebar Color</h6>
      <div class="form-check sidebar-setting">
        <input
          class="form-check-input"
          type="radio"
          name="sidebar-color"
          id="sidebar-color-light"
          value="light"
          [checked]="sidebarcolor === 'light'"
          (change)="changeSidebarColor('light')"
        />
        <label class="form-check-label" for="sidebar-color-light">Light</label>
      </div>
      <div class="form-check sidebar-setting">
        <input
          class="form-check-input"
          type="radio"
          name="sidebar-color"
          id="sidebar-color-dark"
          value="dark"
          [checked]="sidebarcolor === 'dark'"
          (change)="changeSidebarColor('dark')"
        />
        <label class="form-check-label" for="sidebar-color-dark">Dark</label>
      </div>
      <div class="form-check sidebar-setting">
        <input
          class="form-check-input"
          type="radio"
          name="sidebar-color"
          id="sidebar-color-brand"
          value="brand"
          [checked]="sidebarcolor === 'brand'"
          (change)="changeSidebarColor('brand')"
        />
        <label class="form-check-label" for="sidebar-color-brand">Brand</label>
      </div>
      <h6 class="mt-4 mb-3 sidebar-setting">Direction</h6>
      <div class="form-check sidebar-setting form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="layout-direction"
          id="layout-direction-ltr"
          value="dark"
          [checked]="direction === 'ltr'"
          (change)="changeDirection('ltr')"
        />
        <label class="form-check-label" for="layout-direction-ltr">LTR</label>
      </div>
      <div class="form-check sidebar-setting form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="layout-direction"
          id="layout-direction-rtl"
          value="light"
          [checked]="direction === 'rtl'"
          (change)="changeDirection('rtl')"
        />
        <label class="form-check-label" for="layout-direction-rtl">RTL</label>
      </div>
    </div>
  </div>
</div>
